function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import commonMsgs from '../../nls/common.properties';
import hrefs from '../../lib/shared/hrefs';
import msgs from '../../nls/setup/deploy/deploy.properties';
import { PageHeader } from '@console/cloud-pal-community/components/Basic';
import { Button, Tag } from "@carbon/react";
import Phase from '../common/model/phase';
import PropTypes from 'prop-types';
import React from 'react';
import '../../scss/setup/deploy/_deploy-header.scss';
var DeployHeader = /*#__PURE__*/function (_React$Component) {
  function DeployHeader() {
    _classCallCheck(this, DeployHeader);
    return _callSuper(this, DeployHeader, arguments);
  }
  _inherits(DeployHeader, _React$Component);
  return _createClass(DeployHeader, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
        locale = _this$context.locale,
        wizardMode = _this$context.wizardMode;
      var _this$props = this.props,
        icon = _this$props.icon,
        isComplianceTemplate = _this$props.isComplianceTemplate,
        isPublicTemplate = _this$props.isPublicTemplate,
        phase = _this$props.phase,
        title = _this$props.title,
        userInfo = _this$props.userInfo,
        wizard = _this$props.wizard;
      if (phase !== Phase.LOADING) {
        var breadcrumbs = this.breadcrumbs();
        var iconImg;
        var headerClass;
        if (icon) {
          iconImg = /*#__PURE__*/React.createElement("img", {
            className: "template-icon",
            src: icon,
            alt: ""
          });
          headerClass = "page-header-icon-visible";
        }
        var headerChildren;
        if (wizardMode && userInfo && wizard && wizard.isV1()) {
          // Wizard mode renders the details button in the page header
          // Only render the button if the user is fully logged in
          headerChildren = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            kind: "tertiary",
            className: "details-btn",
            onClick: this.props.handleDetailsClicked,
            "data-analytics-track": "setup-details"
          }, msgs.get("label.detailsButton", locale)));
        }
        var surfacedProps = {};
        if (wizardMode && isComplianceTemplate && !isPublicTemplate) {
          // Render "IBM - Internal Only" tags in header for internal compliance templates
          var surfacedTags = /*#__PURE__*/React.createElement("div", {
            id: "header-tags"
          }, /*#__PURE__*/React.createElement(Tag, {
            title: "IBM",
            type: "cyan"
          }, "IBM"), /*#__PURE__*/React.createElement(Tag, {
            title: msgs.get("wizard.header.tag.internal", locale),
            type: "cyan"
          }, msgs.get("wizard.header.tag.internal", locale)));
          surfacedProps = {
            hasSurfacedDetailsList: true,
            surfacedDetails: surfacedTags,
            wrappedDetails: false
          };
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "page-header-container"
        }, /*#__PURE__*/React.createElement(PageHeader, _extends({
          breadcrumbs: breadcrumbs,
          className: headerClass,
          light: true
        }, surfacedProps, {
          title: title || ""
        }), headerChildren, iconImg));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page-header-container"
      }, /*#__PURE__*/React.createElement(PageHeader.skeleton, {
        breadcrumbs: true,
        light: true
      }));
    }
  }, {
    key: "breadcrumbs",
    value: function breadcrumbs() {
      var _this$context2 = this.context,
        envId = _this$context2.envId,
        locale = _this$context2.locale;
      var params = this.props.params;
      if (params.app_id && params.tenant) {
        // Devex bring-your-own-code create flow
        return [{
          href: hrefs.appDetails(params.app_id, params.tenant),
          value: commonMsgs.get('app-details', locale)
        }, {
          href: hrefs.appDeploy(params.app_id, params.tenant),
          value: commonMsgs.get('deploy-my-app', locale)
        }, {
          href: hrefs.createCatalog(envId, {
            id: params.app_id,
            tenant: params.tenant
          }, params),
          value: msgs.get('label.createToolchain', locale)
        }];
      }
      if (params['k8s-cluster-name'] && params['k8s-cluster-id'] && params['k8s-region'] && params['resource-group']) {
        // IKS flow
        return [{
          href: hrefs.clusters(),
          value: commonMsgs.get('clusters', locale)
        }, {
          href: hrefs.clusterDetails('devops', params['k8s-cluster-id'], params['k8s-region'], params['resource-group-id']),
          value: params['k8s-cluster-name']
        }, {
          href: hrefs.createIksCatalog(params['k8s-cluster-name'], params['k8s-cluster-id'], params['k8s-region'], params['resource-group'], params['resource-group-id']),
          value: msgs.get('label.createToolchain', locale)
        }];
      }
      return [{
        href: hrefs.automation(),
        value: commonMsgs.get('automation', locale),
        key: 'automation'
      }, {
        href: hrefs.toolchains(),
        value: commonMsgs.get('toolchains', locale),
        key: 'toolchains'
      }, {
        href: hrefs.createCatalog(envId),
        value: msgs.get('label.createToolchain', locale),
        key: 'create'
      }];
    }
  }]);
}(React.Component);
export { DeployHeader as default };
DeployHeader.contextTypes = {
  envId: PropTypes.string,
  locale: PropTypes.string,
  wizardMode: PropTypes.bool
};
DeployHeader.propTypes = {
  handleDetailsClicked: PropTypes.func,
  params: PropTypes.object.isRequired,
  phase: PropTypes.string,
  title: PropTypes.string
};